<div class="container-fluid p-0">
    <!-- Processing Overlay moved to top level to cover entire modal -->
    <div class="processing-overlay shadow-lg animated fadeIn"
        *ngIf="isProcessing() && activeComponent !== upiQrComponent && activeTab() !== 'upi'">
        <div class="d-flex flex-column align-items-center justify-content-center h-100 text-center px-4">
            <div class="premium-loader mb-4">
                <div class="spinner-outer"></div>
                <div class="spinner-inner"></div>
                <i class="fa fa-shield text-primary position-absolute"></i>
            </div>
            <h5 class="fw-bold mb-2">Processing Your Payment</h5>
            <p class="text-muted small mb-0">Please do not refresh the page or close this window.</p>
            <div class="mt-4 px-3 py-2 bg-light rounded-pill border d-flex align-items-center">
                <i class="fa fa-lock text-success me-2"></i>
                <span class="text-success fw-bold" style="font-size: 0.75rem;">SECURE 256-BIT ENCRYPTION</span>
            </div>
        </div>
    </div>

    <div class="d-flex flex-column flex-md-row h-100">
        <div class="brand-panel-wrapper position-relative text-white pb-5">
            <div class="merchant-section d-flex align-items-start mb-2 mb-md-3">
                <div class="merchant-info d-flex flex-column align-items-start">
                    <div class="d-flex align-items-center mb-2 w-100 pe-2">
                        <div class="merchant-logo bg-white rounded d-flex align-items-center justify-content-center me-3 shadow-sm position-relative"
                            style="width: 48px; height: 48px; min-width: 48px; padding: 2px;">
                            <img [src]="templeLogo" alt="Temple Logo" class="w-100 h-100 rounded"
                                style="object-fit: cover;">
                            <div class="position-absolute top-100 start-100 translate-middle p-1 bg-success border border-light rounded-circle"
                                style="margin-top: -6px; margin-left: -6px; z-index: 2;"></div>
                        </div>
                        <div class="merchant-name text-start lh-sm fw-bold"
                            style="font-size: 1.1rem; overflow-wrap: break-word; hyphens: auto; letter-spacing: -0.2px;">
                            {{ templeName }}
                        </div>
                    </div>

                </div>
            </div>

            <div class="summary-card mt-4 p-3 rounded bg-white shadow-sm">
                <div class="summary-label text-dark fw-bold text-uppercase mb-2 d-flex justify-content-between align-items-center"
                    style="font-size: 0.8rem; border-bottom: 1px solid #f0f0f0; padding-bottom: 6px;">
                    Price Summary
                </div>
                <div class="amount fs-2 fw-bold lh-1 mb-2" style="color: #1a202c;">₹{{ paymentTotal | number:'1.2-2' }}
                </div>

                <div class="d-flex justify-content-between align-items-center pt-2 mt-1"
                    style="border-top: 1px dashed #eaeaea;">
                    <span class="text-muted" style="font-size: 0.7rem;">Incl. convenience fee</span>
                    <span class="text-muted fw-bold" style="font-size: 0.7rem;">₹{{ convenienceCharge | number:'1.2-2'
                        }}</span>
                </div>
            </div>

            <div
                class="trusted-badge position-absolute bottom-0 start-0 m-4 border-0 p-0 fs-6 text-white text-start bg-transparent">
                <div class="opacity-75" style="font-size: 0.70rem;">Secured by <strong
                        class="fs-6 fst-italic">CashFree</strong></div>
            </div>
        </div>

        <!-- Right Panel Container (70%) -->
        <div class="right-panel-wrapper p-2 ps-md-0 h-100">
            <div class="right-panel position-relative p-0 flex-column d-flex h-100 w-100 overflow-hidden bg-white">

                <!-- Top Header for the right side -->
                <div class="d-flex justify-content-between align-items-center px-4 py-2 border-bottom wrapper-hdr"
                    style="min-height: 50px;">
                    <div style="width: 20px;"></div> <!-- Spacer for centering -->
                    <h6 class="mb-0 fw-bold text-dark fs-6 text-center">Payment Options</h6>
                    <div>
                        <!-- Spacer for symmetry or ... option button -->
                        <i class="fa fa-times text-muted fs-5" aria-hidden="true" (click)="attemptClose()"
                            style="cursor: pointer;" title="Close Modal"></i>
                    </div>
                </div>

                <!-- Main Right Body Component (Options + Details) -->
                <div class="d-flex flex-column flex-md-row flex-grow-1 overflow-hidden" style="min-height: 0;">

                    <!-- COLUMN 2 - Options List -->
                    <div class="options-panel px-2 py-2 overflow-y-auto">
                        <div class="payment-options-list">
                            <!-- UPI -->
                            <div class="option-item" [ngClass]="{'active': activeTab() === 'upi'}"
                                (click)="switchTab('upi')">
                                <div class="left-content">
                                    <div class="method-info">
                                        <div class="name" style="font-size: 0.85rem; font-weight: 700;">UPI</div>
                                    </div>
                                </div>
                                <div class="right-content">
                                    <div class="icons rounded-circle">
                                        <i class="fa fa-qrcode" style="color: #6c757d; font-size: 0.9rem;"></i>
                                    </div>
                                </div>
                            </div>

                            <!-- Cards -->
                            <div class="option-item" [ngClass]="{'active': activeTab() === 'card'}"
                                (click)="switchTab('card')">
                                <div class="left-content">
                                    <div class="method-info">
                                        <div class="name" style="font-size: 0.85rem; font-weight: 700;">Cards</div>
                                    </div>
                                </div>
                                <div class="right-content">
                                    <div class="icons text-muted" style="font-size: 0.9rem;">
                                        <i class="fa fa-cc-mastercard"></i>
                                        <i class="fa fa-cc-visa"></i>
                                    </div>
                                </div>
                            </div>

                            <!-- Netbanking -->
                            <div class="option-item" [ngClass]="{'active': activeTab() === 'netbanking'}"
                                (click)="switchTab('netbanking')">
                                <div class="left-content">
                                    <div class="method-info">
                                        <div class="name" style="font-size: 0.85rem; font-weight: 700;">Netbanking</div>
                                    </div>
                                </div>
                                <div class="right-content">
                                    <div class="icons text-muted">
                                        <i class="fa fa-bank border rounded-circle p-1" style="font-size: 0.8rem;"></i>
                                    </div>
                                </div>
                            </div>

                            <!-- Wallet -->
                            <div class="option-item" [ngClass]="{'active': activeTab() === 'wallet'}"
                                (click)="switchTab('wallet')">
                                <div class="left-content">
                                    <div class="method-info">
                                        <div class="name" style="font-size: 0.85rem; font-weight: 700;">Wallet</div>
                                    </div>
                                </div>
                                <div class="right-content">
                                    <div class="icons text-muted">
                                        <i class="fa fa-google-wallet border rounded-circle p-1"
                                            style="font-size: 0.8rem;"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- COLUMN 3 - Method Details -->
                    <div
                        class="details-panel flex-grow-1 p-3 p-md-4 position-relative overflow-y-auto border-start bg-white">

                        <!-- UPI Content -->
                        <div class="notranslate upi-qr-section animated fadeIn h-100 d-flex flex-column"
                            [class.d-none]="activeTab() !== 'upi'">
                            <div class="qr-header d-flex justify-content-between align-items-center mb-2">
                                <div class="label fw-bold" style="font-size: 0.8rem; color: #a1a5a8;">UPI QR</div>
                                <div class="timer text-dark fw-bold border border-light rounded px-2 py-1 d-flex align-items-center shadow-sm bg-white"
                                    style="font-size: 0.8rem;">
                                    <i class="fa fa-clock-o me-1"></i> {{ formattedTime() }}
                                </div>
                            </div>

                            <!-- Horizontal QR Box (Desktop) -->
                            <div *ngIf="!isMobile"
                                class="p-3 rounded-3 border d-flex flex-row align-items-center flex-grow-0 mb-3 bg-light"
                                style="border-color: #eaeaea !important;">
                                <!-- QR Code side -->
                                <div id="upi-qr-container"
                                    class="bg-white p-2 rounded shadow-sm me-3 d-flex align-items-center justify-content-center flex-shrink-0"
                                    style="width: 220px; height: 220px;">
                                    <!-- QR Code mounts here -->
                                </div>

                                <!-- Text/Icons side -->
                                <div class="d-flex flex-column text-start align-items-start">
                                    <div class="fw-bold text-dark mb-2" style="font-size: 0.75rem; color: #6c757d;">Scan
                                        the QR using any UPI App</div>
                                    <div class="d-flex gap-2 align-items-center text-secondary">
                                        <i class="fa fa-google fa-lg bg-dark text-white rounded p-1"
                                            style="font-size: 0.7rem;"></i>
                                        <i class="fa fa-amazon fa-lg border rounded p-1 text-dark"
                                            style="font-size: 0.7rem;"></i>
                                        <i class="fa fa-cc-paypal fa-lg border rounded p-1 text-primary"
                                            style="font-size: 0.7rem;"></i>
                                    </div>
                                </div>
                            </div>

                            <!-- UPI Apps Grid (Mobile) -->
                            <div *ngIf="isMobile" class="upi-apps-container mb-3">
                                <div class="apps-grid">
                                    <div class="app-item">
                                        <div id="gpay-app-container"></div>
                                    </div>
                                    <div class="app-item">
                                        <div id="phonepe-app-container"></div>
                                    </div>
                                    <div class="app-item">
                                        <div id="paytm-app-container"></div>
                                    </div>
                                    <div class="app-item">
                                        <div id="other-upi-container"></div>
                                    </div>
                                </div>
                                <div class="text-center mt-2">
                                    <small class="text-muted" style="font-size: 0.7rem;">Tap to open your preferred UPI
                                        App</small>
                                </div>
                            </div>

                            <div class="divider text-center my-4">
                                <span class="bg-white px-3 text-muted"
                                    style="font-size: 0.65rem; font-weight: 700; letter-spacing: 0.5px;">OR PAY USING
                                    UPI ID</span>
                            </div>

                            <div class="upi-id-block mt-2">
                                <div class="upi-id-box mb-3">
                                    <div id="upi-collect-container"></div>
                                </div>
                                <div class="pb-1">
                                    <button class="btn btn-dark w-100 fw-bold text-uppercase shadow-sm payment-btn"
                                        (click)="payWithUpiCollect()" style="letter-spacing: 0.5px;">
                                        Pay with UPI ID
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Card Content -->
                        <div class="card-details-box animated fadeIn" [class.d-none]="activeTab() !== 'card'">
                            <h6 class="fw-bold mb-4">Enter Card Details</h6>
                            <div class="mb-3">
                                <label class="form-label">Card Number</label>
                                <div id="card-number"></div>
                            </div>
                            <div class="mb-3">
                                <label class="form-label">Card Holder Name</label>
                                <div id="card-holder"></div>
                            </div>
                            <div class="row g-2 mb-4">
                                <div class="col-6">
                                    <label class="form-label">Expiry</label>
                                    <div id="card-expiry"></div>
                                </div>
                                <div class="col-6">
                                    <label class="form-label">CVV</label>
                                    <div id="card-cvv"></div>
                                </div>
                            </div>
                            <button class="btn btn-dark w-100 fw-bold shadow-sm" (click)="payWithCard()">
                                Pay ₹{{ paymentTotal | number:'1.2-2' }}
                            </button>
                        </div>

                        <!-- Netbanking Content -->
                        <div class="netbanking-box animated fadeIn" [class.d-none]="activeTab() !== 'netbanking'">
                            <div class="search-group mb-4">
                                <div class="input-group">
                                    <span class="input-group-text bg-white border-end-0">
                                        <i class="fa fa-search text-muted"></i>
                                    </span>
                                    <input type="text" class="form-control border-start-0 ps-0"
                                        placeholder="Search for Banks" (input)="onSearch($event)"
                                        [(ngModel)]="searchTerm">
                                </div>
                            </div>

                            <div class="popular-banks-section" [class.d-none]="searchTerm && !hasSuggestedMatches">
                                <h6 class="section-title-small mb-3">Popular Banks</h6>
                                <div class="bank-list mb-4">
                                    <div class="bank-list-item popular-bank-item" *ngFor="let bank of suggestedBanks"
                                        [class.d-none]="!isBankMatch(bank)">
                                        <div [id]="'nb-suggested-' + bank.code" class="nb-sdk-container w-100"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="all-banks-section">
                                <h6 class="section-title-small mb-3">{{ searchTerm ? 'Search Results' : 'All Banks' }}
                                </h6>
                                <div class="bank-list">
                                    <div class="bank-list-item bank-row-item" *ngFor="let bank of allBanks"
                                        [class.d-none]="!isBankMatch(bank)">
                                        <div [id]="'nb-all-' + bank.code" class="nb-sdk-container w-100"></div>
                                    </div>
                                    <div *ngIf="!hasSearchResults" class="text-center py-4 text-muted">
                                        No banks found matching "{{ searchTerm }}"
                                    </div>
                                </div>
                            </div>

                            <!-- Hidden container for mounting the Cashfree handler -->
                            <div id="netbanking-container"></div>
                        </div>

                        <!-- Wallet Content -->
                        <div class="wallet-box animated fadeIn" [class.d-none]="activeTab() !== 'wallet'">
                            <h6 class="fw-bold mb-3">Select Your Wallet</h6>
                            <p class="text-muted small mb-3" style="font-size: 0.75rem;">Tap a wallet below to pay
                                instantly</p>

                            <div class="wallet-grid">
                                <div *ngFor="let wallet of activeWallets" class="wallet-card-item">
                                    <div [id]="'wallet-' + wallet.code" class="wallet-sdk-container"></div>
                                </div>
                            </div>
                        </div>


                        <!-- Placeholder -->
                        <div class="details-placeholder m-auto h-100 d-flex flex-column align-items-center justify-content-center"
                            [class.d-none]="activeTab()">
                            <i class="fa fa-mouse-pointer fs-1 text-black-50 mb-3"></i>
                            <p class="mb-0 text-muted">Select a payment method to proceed</p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>

<!-- Cancel Confirmation Overlay -->
<div class="cancel-confirm-overlay" *ngIf="showCancelConfirm">
    <div class="cancel-confirm-box slide-up-animation">
        <div class="d-flex align-items-center mb-3 text-danger">
            <i class="fa fa-exclamation-triangle fa-lg me-2"></i>
            <h5 class="fw-bold mb-0">Cancel Payment?</h5>
        </div>
        <p class="text-secondary mb-4" style="font-size: 0.95rem;">Are you sure you want to cancel this payment? Your
            transaction will be aborted.</p>
        <div class="d-flex flex-column-reverse flex-sm-row gap-2 justify-content-end w-100">
            <button class="btn btn-light fw-bold border px-3 flex-grow-1" (click)="cancelClose()">No, Continue</button>
            <button class="btn btn-danger fw-bold px-4 flex-grow-1" (click)="confirmClose()">Yes, Cancel</button>
        </div>
    </div>
</div>